/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./index.css";

import { useNavigate } from "react-router-dom";

import { AdminRoutePath } from "#routes/routePath.jsx";

export default function NotFound() {
  const navigation = useNavigate();

  return (
    <section className="page_404">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 ">
            <div className="col-sm-offset-1  text-center">
              <div className="four_zero_four_bg">
                <h1 className="text-center ">404</h1>
              </div>
              <div className="contant_box_404">
                <h3 className="h2">Look like you're lost</h3>
                <p>the page you are looking for not available!</p>
                <a
                  onClick={() => navigation(AdminRoutePath.LOGIN.path)}
                  className="link_404"
                >
                  Go to Home
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
